if (!customElements.get("custom-swiper")) {
  class CustomSwiper extends HTMLElement {
    constructor() {
      super();
      this.conf = {
        sectionId: this.dataset.sectionId,
        direction: this.dataset.direction || "horizontal",
        mDirection: this.dataset.mDirection || "horizontal",
        loop: this.dataset.loop === "true",
        enableWheel: this.dataset.enableWheel === "true",
        enablePin: this.dataset.enablePin === "true",
        enablePinMb: this.dataset.enablePinMb === "true",
        showNav: this.dataset.showNav === "true",
        showPagination: this.dataset.showPagination === "true",
        enableScrollbar: this.dataset.enableScrollbar === "true",
        blocksCount: parseInt(this.dataset.blocksCount) || 0,
        breakpoint: 769,
        pinContainer: this.querySelector(".pin-container"),
        fade: this.dataset.enableFade === "true",
        pcSlidesper: this.dataset.pcSlidesper,
        mSlidesper: this.dataset.mSlidesper,
        autoplayDelay: this.dataset.autoplayDelay || 0,
        enablePinAll: this.dataset.enablePinAll,
      };
      this.conf.container=document.querySelector(`.section-${this.conf.sectionId}`);
      this.conf.textSwitchItems = this.conf.container.querySelectorAll(`.text-overlay__switch-item`);
      this.conf.textSwitchSwiper = this.conf.container.querySelector(`.text-switch-swiper-${this.conf.sectionId}`);

      this.isVertical = false;
      this.allowTouchMove = true;
      this.enableEffect = false;
      this.swiper = null;
      this.textSwitchSwiper = null;
      this.observer = null;
      this.initialized = false;
      this.timeline = null;
      if(this.conf.enablePinAll == 'enable_pin_all_2' && window.innerWidth < 1800  && window.innerWidth > 769){ 
        this.conf.pinContainer = this.conf.container.querySelector(".pin-container .custom-swiper__block");
      }
    }

    connectedCallback() {
      this.initIntersectionObserver();
    }

    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.initialized) {
              this.initialized = true;
              this.observer.disconnect();
              this.init();
              this._resizeHandler = this.debounce(
                () => requestAnimationFrame(() => this.handleResize()),
                250,
              );
              window.addEventListener("resize", this._resizeHandler);
              window.addEventListener("load", () => {
                if(this.conf.pinContainer){
                  if (window.scheduleScrollTriggerRefresh) {
                    window.scheduleScrollTriggerRefresh();
                  }
                }
              });
            }
          });
        },
        { rootMargin: "0px 0px 100px 0px", threshold: 0.1 },
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.destroyAll();
      window.removeEventListener("resize", this._resizeHandler);
    }

    init() {
      // 1. clear all inline styles that may interfere with the swiper
      const elementsToClear = [
        this,
        this.querySelector(".custom-swiper__content .swiper"),
        this.conf.pinContainer,
      ];
      elementsToClear.forEach((el) => {
        if (el) el.removeAttribute("style");
      });

      // 2. calculate the aspect ratio of the swiper
      this.checkDirection();
      this.initSwiper();

      // 3. 处理 Pin 逻辑
      const isMobile = window.innerWidth < this.conf.breakpoint;
      const shouldPin = isMobile ? this.conf.enablePinMb : this.conf.enablePin;

      if (shouldPin && this.conf.pinContainer) {
        // configure the swiper to allow pinning
        requestAnimationFrame(() => {
          this.isPin();
        });
      }
    }

    isPin() {
      if (!this.swiper || this.conf.blocksCount <= 1) return;

      if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
        gsap.registerPlugin(ScrollTrigger);
      }

      let h = window.innerHeight * (this.conf.blocksCount - 1);
      const slidesLen = this.swiper.slides.length;
      this.timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this.conf.pinContainer,
          start: "0 0",
          end: `+=${h}`,
          scrub: 1,
          pin: true,
          pinSpacing: true,
          anticipatePin: 1,
          snap: 1 / (slidesLen - 1),
          invalidateOnRefresh: true,
        },
      });

      this.swiper.slides.forEach((slide, i) => {
        this.timeline.to(
          {},
          {
            duration: i === 0 ? 0 : 1,
            onStart: () => {
              this.swiper.slideTo(i);
              this.handleVideoPlayback();
            },
            onReverseComplete: () => {
              if (i > 0) this.swiper.slideTo(i - 1);
              this.handleVideoPlayback();
            },
          },
          i === 0 ? 0 : ">",
        );
      });

      // Use debounced refresh to avoid conflicts with other pinned sections
      if (window.scheduleScrollTriggerRefresh) {
        window.scheduleScrollTriggerRefresh();
      }
    }

    checkDirection() {
      const isMobile = window.innerWidth < this.conf.breakpoint;
      this.isVertical = isMobile
        ? this.conf.mDirection === "vertical"
        : this.conf.direction === "vertical";

      // mobile always allow touch move
      this.allowTouchMove = isMobile ? true : !this.conf.enablePin;

      this.enableEffect = isMobile
        ? false
        : this.conf.enablePin || this.conf.enablePinMb;
      if(this.conf.fade){
        this.enableEffect = true;
      }
    }

    getSwiperConfig() {
      const isMobile = window.innerWidth < this.conf.breakpoint;
      const slidesPerView = isMobile ? this.conf.mSlidesper : this.conf.pcSlidesper;
      const spaceBetween = Number.isInteger(slidesPerView) ? 0 : (isMobile ? 20 : 40)
      
      const config = {
        direction: this.isVertical ? "vertical" : "horizontal",
        loop: this.conf.loop,
        speed: 600,
        grabCursor: true,
        spaceBetween:spaceBetween,
        allowTouchMove: this.allowTouchMove,
        effect: this.enableEffect ? "fade" : "slide",
        fadeEffect: { crossFade: true },
        slidesPerView: slidesPerView,
        navigation: this.conf.showNav
          ? {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          }
          : false,
        pagination: this.conf.showPagination
          ? { el: this.querySelector(".swiper-pagination"), clickable: true }
          : false,
        scrollbar: this.conf.enableScrollbar
          ? { el: this.querySelector(".swiper-scrollbar"), draggable: true }
          : false,
        mousewheel: this.conf.enableWheel ? { releaseOnEdges: true } : false,
        on: {
          init: (s) => {
            if (this.isVertical) this.setMaxHeight(s);
          },
          slideChangeTransitionEnd: () => {
            this.handleVideoPlayback();
          },
        },
      };
      
      if (this.conf.autoplayDelay > 0) {
        config.autoplay = {
          delay: this.conf.autoplayDelay,
          disableOnInteraction: false,
        };
      }
      
      return config;
    }

    initSwiper() {
      const container = this.querySelector(".custom-swiper__content .swiper");
      if (!container) return;
      this.swiper = new Swiper(container, this.getSwiperConfig());
      this.initTextSwitch();
      this.initTextSwitchSwiper();
      this.initScheme2();
    }

    initTextSwitch() {
     const textSwitchItems = this.conf.textSwitchItems;
      if (textSwitchItems.length > 0) {
        textSwitchItems.forEach((item, index) => {
          item.addEventListener('click', () => {
            this.swiper.slideTo(index);
            this.updateTextSwitchActive(index);
          });
        });
        this.swiper.on('slideChange', () => {
          const activeIndex = this.swiper.activeIndex;
          this.updateTextSwitchActive(activeIndex);
        });
        this.updateTextSwitchActive(0);
      }
    }

    initTextSwitchSwiper() {
      const textSwitchSwiperEl = this.conf.textSwitchSwiper;
      if (textSwitchSwiperEl) {
        const isMobile = window.innerWidth < this.conf.breakpoint;
        this.textSwitchSwiper = new Swiper(textSwitchSwiperEl, {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 16,
          freeMode: true,
          allowTouchMove: isMobile,
          on: {
            slideChange: () => {
              const activeIndex = this.textSwitchSwiper.activeIndex;
              this.swiper.slideTo(activeIndex);
              this.updateTextSwitchActive(activeIndex);
            }
          }
        });
        
        this.swiper.on('slideChange', () => {
          const activeIndex = this.swiper.activeIndex;
          if (this.textSwitchSwiper) {
            this.textSwitchSwiper.slideTo(activeIndex, 300);
          }
          this.updateTextSwitchActive(activeIndex);
        });
      }
    }

    updateTextSwitchActive(activeIndex) {
      const textSwitchItems = this.conf.textSwitchItems;
      textSwitchItems.forEach((item, index) => {
        if (index === activeIndex) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    initScheme2() {
      const titles = this.conf.container.querySelectorAll(`.scheme-2-item`);
      
      if (titles.length > 0) {
        titles.forEach((title, index) => {
          title.addEventListener('click', () => {
            this.swiper.slideTo(index);
            this.updateScheme2Active(index);
          });
        });
        
        this.swiper.on('slideChange', () => {
          const activeIndex = this.swiper.activeIndex;
          this.updateScheme2Active(activeIndex);
        });
      }
    }

    updateScheme2Active(activeIndex) {
      const titles = this.conf.container.querySelectorAll(`.scheme-2-title`);
      
      titles.forEach((title, index) => {
        if (index === activeIndex) {
          title.closest(".scheme-2-item").classList.add('active');
        } else {
          title.closest(".scheme-2-item").classList.remove('active');
        }
      });
      
    }

    handleResize() {
      const isMobile = window.innerWidth < this.conf.breakpoint;
      // check if the direction changed
      this.destroyAll();
      this.init();
    }

    destroyAll() {
      // 1. destroy the swiper instance
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      // 2. destroy the text switch swiper instance
      if (this.textSwitchSwiper) {
        this.textSwitchSwiper.destroy(true, true);
        this.textSwitchSwiper = null;
      }

      // 3. destroy the scrolltrigger instance
      if (this.timeline) {
        this.timeline.scrollTrigger?.kill(true);
        this.timeline.kill();
        this.timeline = null;
      }

      // 4. reset the height of the swiper container
      const swiperEl = this.querySelector(".swiper");
      if (swiperEl) swiperEl.style.height = "";
      this.style.height = "";

      // 5. reset the pin container
      if(this.conf.pinContainer){
        if (window.scheduleScrollTriggerRefresh) {
          window.scheduleScrollTriggerRefresh();
        }
      }
    }

    setMaxHeight(swiperInstance) {
      const slides = swiperInstance.slides;
      let maxHeight = 0;
      slides.forEach((slide) => {
        const content = slide.querySelector(".slide-content") || slide;
        maxHeight = Math.max(maxHeight, content.offsetHeight);
      });
      if (maxHeight > 0) {
        this.querySelector(".swiper").style.height = `${maxHeight}px`;
        swiperInstance.update();
      }
    }

    handleVideoPlayback() {
      const videoComponents = this.querySelectorAll("video-component");
      videoComponents.forEach((component) => {
        const slide = component.closest(".swiper-slide");
        const isActive =
          this.swiper && slide === this.swiper.slides[this.swiper.activeIndex];
        if (isActive) {
          component.inViewport = true;
          component.pausedByUser = false;
          component.play?.();
        } else {
          component.inViewport = false;
          component.pause?.();
        }
      });
    }

    debounce(fn, ms) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), ms);
      };
    }
  }

  customElements.define("custom-swiper", CustomSwiper);
}
